import { render, staticRenderFns } from "./peaTable.vue?vue&type=template&id=428320a7&scoped=true"
import script from "./peaTable.vue?vue&type=script&lang=js"
export * from "./peaTable.vue?vue&type=script&lang=js"
import style0 from "./peaTable.vue?vue&type=style&index=0&id=428320a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428320a7",
  null
  
)

export default component.exports